import i18next from "i18next";
import {
  About,
  LegalInformation,
  LinkItem,
  LinksBlock,
  LogosBlock,
  Opportunities,
  PaymentsLogo,
  Socials,
  SocialsLink,
  Wrapper,
} from "./style";

const FooterTopComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <LinksBlock>
        <LegalInformation>
          <h2>{t("legal_information")}</h2>
          <div>
            <LinkItem to="/rules-of-use-info">{t("rules_of_use")}</LinkItem>
            <LinkItem to="/public-offer-info">{t("offer")}</LinkItem>
            <LinkItem to="/privacy-policy-info">{t("privacy_policy")}</LinkItem>
            <LinkItem to="/payment-info">{t("payment")}</LinkItem>
            <LinkItem to="/refund-request">{t("refund_order")}</LinkItem>
            <LinkItem to="/support">{t("support_footer_link")}</LinkItem>
          </div>
        </LegalInformation>

        <Opportunities>
          <h2>{t("opportunities")}</h2>
          <LinkItem to="/airlines">{t("airlines")}</LinkItem>
          <LinkItem to="/partners">{t("partners")}</LinkItem>
          <LinkItem to="/flights">{t("flights")}</LinkItem>
        </Opportunities>

        <About>
          <h2>{t("wannatalk")}</h2>
          <div>
            <LinkItem to="/about">{t("about_company")}</LinkItem>
            <LinkItem to="/contacts">{t("contact_information")}</LinkItem>
          </div>
          <SocialsLink>
            <LinkItem href="#" target="_blank">
              <Socials src="/socials/max.png" alt="Max-logo" />
            </LinkItem>
            <LinkItem href="#" target="_blank">
              <Socials src="/socials/telegram-white.svg" alt="Telegram-logo" />
            </LinkItem>
          </SocialsLink>
        </About>
      </LinksBlock>

      <LogosBlock>
        <PaymentsLogo src="/images/payment-logos.png" alt="payment-logos" />
      </LogosBlock>
    </Wrapper>
  );
};

export default FooterTopComponent;
